import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { BookingProvider } from "@/context/BookingContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { BookingModal } from "@/components/BookingModal";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import NDIS from "@/pages/NDIS";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Reviews from "@/pages/Reviews";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
};

const AdminRedirect = () => {
  useEffect(() => {
    window.location.replace("https://flowmotive.au/admin");
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center px-6 text-center">
      <p>
        Opening the FlowMotive admin workspace.{" "}
        <a className="underline" href="https://flowmotive.au/admin">Continue to FlowMotive</a>
      </p>
    </div>
  );
};

const Chrome = ({ children }) => {
  const { pathname } = useLocation();
  const bare = pathname === "/admin";
  return (
    <>
      {!bare && <Navbar />}
      <main>{children}</main>
      {!bare && <Footer />}
      {!bare && <BookingModal />}
    </>
  );
};

function App() {
  return (
    <div className="App min-h-screen bg-sora-bg">
      <BrowserRouter>
        <BookingProvider>
          <ScrollToTop />
          <Chrome>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/ndis" element={<NDIS />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin" element={<AdminRedirect />} />
            </Routes>
          </Chrome>
          <Toaster position="top-center" />
        </BookingProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
